module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "Name": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nombre"])},
        "Ranking": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Clasificación"])},
        "Market Capital": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Capital de Mercado"])},
        "Price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio"])},
        "Variation 24hs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Variacion 24hs"])},
        "Search": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar"])},
        "Detail": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Detalle"])}
      }
    }
  })
  Component.options.__i18nBridge = Component.options.__i18nBridge || []
  Component.options.__i18nBridge.push('{"es":{"Name":"Nombre","Ranking":"Clasificación","Market Capital":"Capital de Mercado","Price":"Precio","Variation 24hs":"Variacion 24hs","Search":"Buscar","Detail":"Detalle"}}')
  delete Component.options._Ctor
  
}
